function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 8V0H8v8H0v2h8v8h2v-8h8V8h-8z",
  fill: "#65dbaf"
});

var SvgBespokenIconPlusSign = function SvgBespokenIconPlusSign(props) {
  return React.createElement("svg", _extends({
    viewBox: "-3 -3 24 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgBespokenIconPlusSign;